import SettingsState from './SettingsContext/SettingsState'
import PreferencesState from './PreferencesContext/PreferencesState'
import OpenningManagementState from './OpenningsManagmentContext/OpenningManagementState'
import BuildingsManagementState from './BuildingManagementContext/BuildingsManagementState'
import AreasManagementState from './AreasManagementContext/AreasManagementState'
import PeopleToVisitManagementState from './PeopleToVisitContext/PeopleToVisitManagementState'
import SectorsManagementState from './SectorsContext/SectorsManagementState'
import EquipmentOrToolsTypesState from './EquipmentOrToolsTypes/EquipmentOrToolsTypesState'

const ConfigContext = ({ children }) => {
    return (
        <SettingsState>
            <PreferencesState>
                <OpenningManagementState>
                    <PeopleToVisitManagementState>
                        <SectorsManagementState>
                            <AreasManagementState>
                                <BuildingsManagementState>
                                    <PeopleToVisitManagementState>
                                        <EquipmentOrToolsTypesState>
                                            {children}
                                        </EquipmentOrToolsTypesState>
                                    </PeopleToVisitManagementState>
                                </BuildingsManagementState>
                            </AreasManagementState>
                        </SectorsManagementState >
                    </PeopleToVisitManagementState>
                </OpenningManagementState>
            </PreferencesState>
        </SettingsState>


    )
}

export default ConfigContext